import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { baseColors, darkColors } from "../../theme/colors";
import { Flex, Box } from "../Box";
import { Link } from "../Link";
import { StyledFooter, StyledIconMobileContainer, StyledList, StyledListItem, StyledText, StyledSocialLinks, StyledToolsContainer } from "./styles";
import LangSelector from "../LangSelector/LangSelector";
import { LogoWithTextIcon } from "../Svg";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                        isDark: true,
                        width: "130px"
                    })
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    order: [
                        2,
                        null,
                        1
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: [
                        "42px",
                        null,
                        "36px"
                    ],
                    children: [
                        items === null || items === void 0 ? void 0 : items.map(function(item) {
                            var ref;
                            /*#__PURE__*/ return _jsxs(StyledList, {
                                children: [
                                    /*#__PURE__*/ _jsx(StyledListItem, {
                                        children: item.label
                                    }),
                                    (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                        var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
                                        return /*#__PURE__*/ _jsx(StyledListItem, {
                                            children: href ? /*#__PURE__*/ _jsx(Link, {
                                                href: href,
                                                target: "_blank",
                                                rel: "noreferrer noopener",
                                                color: isHighlighted ? baseColors.warning : darkColors.text,
                                                bold: false,
                                                children: label
                                            }) : /*#__PURE__*/ _jsx(StyledText, {
                                                children: label
                                            })
                                        }, label);
                                    })
                                ]
                            }, item.label);
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            display: [
                                "none",
                                null,
                                "block"
                            ],
                            children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                                isDark: true,
                                width: "160px"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledSocialLinks, {
                    order: [
                        2
                    ],
                    pb: [
                        "42px",
                        null,
                        "32px"
                    ],
                    mb: [
                        "0",
                        null,
                        "32px"
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledToolsContainer, {
                    order: [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ _jsx(Flex, {
                        order: [
                            1,
                            null,
                            1
                        ],
                        alignItems: "center",
                        children: /*#__PURE__*/ _jsx(LangSelector, {
                            currentLang: currentLang,
                            langs: langs,
                            setLang: setLang,
                            color: darkColors.textSubtle,
                            dropdownPosition: "top-right"
                        })
                    })
                })
            ]
        })
    }));
};
export default MenuItem;
